import * as React from "react";
import { Link } from "react-router-dom";
import SearchBox from "../searchBox";

import classes from './index.module.scss';


const Headers = (props: any) => {
  const username = localStorage.getItem("name")
  return (
    <div className={classes.navbar}>
      <div className="d-flex">
        <Link to="/vitrin/categories" className={classes.logo}>VitrinShop</Link>
        <SearchBox />
      </div>
      <div className="d-flex">
        <Link className={classes.btnOutline + " ml-2"} to="/">پنل روناد</Link>
        <div className={classes.dropdownBox + " d-flex"}>
          <img className="ml-1" src="/vitrin/icons/account-outline.svg" alt="user" />
          <span>{username}</span>
          <span className="down-arrow"></span>
          <ul className={classes.list}>
            <li className="d-flex">
              <Link className={classes.link} to="/your-products">
                <img className="ml-1" src="/vitrin/icons/bookmark-outline.svg" alt="user" /><span>کالاهای منتخب</span>
              </Link>
            </li>
            <li className="d-flex">
              <Link className={classes.link} to="/your-products">
                <img className="ml-1" src="/vitrin/icons/package-variant.svg" alt="user" /><span>کالاهای من در ویترین</span>
              </Link>
            </li>
            <li className="d-flex">
              <Link className={classes.link} to="/vitrin-orders">
                <img className="ml-1" src="/vitrin/icons/package-variant-closed.svg" alt="user" /><span>سفارش های من</span>
              </Link>
            </li>
            <li className="d-flex">
              <Link className={classes.link} to="/incoming-orders">
                <img className="ml-1" src="/vitrin/icons/text-box-outline.svg" alt="user" /><span>سفارش های دریافتی</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Headers;